<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <router-link to="/expert">
            <v-img
              alt="Vuetify Logo"
              class="shrink ml-2"
              contain
              src="@/assets/agriportal-logo.png"
              transition="scale-transition"
              :width="155"
            />
          </router-link>
        </v-list-item>
      </template>
      <v-divider/>
      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.to"
          exact
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list
          dense
          nav
        >
          <v-list-item
            to="/"
            exact
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trang cổng</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"/>
      <v-toolbar-title
        v-if="authMod.user.user.info.expert"
        class="text-capitalize"
      >
        {{authMod.user.user.name}}
        - {{authMod.user.user.info.expert.branch.name}}
      </v-toolbar-title>
      <v-spacer/>
      <v-badge
        top
        right
        color="error"
        :content="qasNotRespCounter > 0 ? qasNotRespCounter : '0'"
        offset-x="20"
        offset-y="20"
        class="mr-4"
      >
        <v-btn icon to="/expert/mail-box">
          <v-icon :class="{ 'bounce': qasNotRespCounter > 0 }">mdi-bell-ring-outline</v-icon>
        </v-btn>
      </v-badge>
      <v-menu offset-y="offset-y">
        <template v-slot:activator="{ on }">
          <v-avatar size="46px" v-on="on" style="cursor: pointer;">
            <v-img 
              v-if="authMod.user.user.info.anh_dai_dien"
              :src="`${apiBaseUrl}/uploads/${authMod.user.user.info.anh_dai_dien}`"
            />
            <v-img v-else src="@/assets/user-default.jpg"/>
          </v-avatar>
        </template>
        <v-list nav dense>
          <v-list-item :to="{name: 'Home'}">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trang cổng</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showProfileDialog">
            <v-list-item-icon>
              <v-icon>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Thông tin cá nhân</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="changePassword">
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Đổi mật khẩu</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Đăng xuất</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-alert
          v-if="late > 0"
          type="warning"
          icon="mdi-emoticon-sad-outline"
          border="top"
          elevation="2"
          colored-border
          dismissible
        >
          Anh (Chị) có <strong class="pink--text">{{late}}</strong> câu hỏi bị trễ hạn!
        </v-alert>
        <router-view/>
      </v-container>
    </v-main>
    <ChangePassword 
      :showDialog="dialogChangePassword" 
      :item="itemChangePassword" 
      @confirmed="onChangePasswordConfirmed" 
      @cancelled="onChangePasswordCancelled"
    />
    <Profile 
      :showDialog="profileDialog" 
      :item="userProfile" 
      @confirmed="onProfileConfirmed" 
      @cancelled="onProfileCancelled"
    />
    <v-btn
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="getDocument"
    >
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon 
            v-bind="attrs"
            v-on="on"
          >
            mdi-book-open-variant
          </v-icon>
        </template>
        <span>Hướng dẫn sử dụng</span>
      </v-tooltip>
    </v-btn>
  </v-app>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import ChangePassword from '@/views/auth/password/ChangePassword'
  import Profile from '@/views/user/Profile'
  export default {
    components: {
      ChangePassword,
      Profile
    },
    data () {
      return {
        items: [
          { title: 'Tổng quan', icon: 'mdi-view-dashboard', to: '/expert' },
          { title: 'Hộp thư', icon: 'mdi-mailbox-open', to: '/expert/mail-box' }
        ],
        right: null,
        drawer: null,
        dialogChangePassword: false,
        itemChangePassword: {},
        profileDialog: false,
        userProfile: {},
        late: 0
      }
    },
    computed: {
      ...mapState([
        'authMod',
        'qasNotRespCounter',
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật'
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.countQasNotResp(this.authMod.user.user.info.coso_id)
      this.countQasAmountByStatus(2)
    },
    methods: {
      ...mapActions([
        'logout',
        'countQasNotResp'
      ]),
      countQasAmountByStatus (status) {
        const app = this
        let expertId = app.authMod.user.user.info.coso_id
        axios.get(`api/v1/supports-counter-bystatus/${expertId}/${status}`)
          .then(response => {
            app.late = response.data
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      changePassword(){
        this.itemChangePassword = {}
        this.dialogChangePassword = true
      },
      onChangePasswordConfirmed(item) {
        this.dialogChangePassword = false
      },
      onChangePasswordCancelled () {
        this.dialogChangePassword = false 
      },
      showProfileDialog(item=null){
        axios.get(`api/v1/users/${this.authMod.user.user.id}`)
          .then(response => {
            this.userProfile = response.data;
            this.profileDialog = true
          })
          .catch(function (error) {
          console.log(error);
          });
      },
      onProfileConfirmed(item) {
        this.profileDialog = false 
      },
      onProfileCancelled () {
        this.profileDialog = false 
      },
      getDocument(){
        window.open(
          `${this.config.beUrl}/document/HDSD_KetNoiNongNghiep.pdf`,
          '_blank'
        );
      }
    }
  }
</script>
<style lang="scss" scoped>
  @mixin ballb($yaxis: 0) {
    transform: translate3d(0, $yaxis, 0);
  }
  @keyframes bouncein {
    0%, 50% { @include ballb(-3px); }
    25%, 75%, 100% { @include ballb() }
  }
  .bounce {
    animation: bouncein 1500ms cubic-bezier(0.25, 0.46, 0.45, 0.94) both infinite;
  }
</style>